module.exports = __webpack_public_path__ + "21006c9ab5e6a056da25b0acf36084bb.fbx";